export class TopicServiceInterface {
}
